module.exports = __webpack_public_path__ + "static/img/logo4.79b16cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo4.png
// module id = 1F0D
// module chunks = 1